<div class="width-1100">

  <mat-card>

    <mat-toolbar class="toolbar-top">

      <div class='title' style='padding: 10px;'>
        CAEX - Inscrições
      </div>

      <button mat-button (click)='goBack()'>
        <mat-icon>arrow_back</mat-icon>
      </button>

    </mat-toolbar>

  </mat-card>

  <div class='div-progress'>
    <mat-progress-bar [ngClass]="{hidden: !spinner}" color='warn' mode="indeterminate">
    </mat-progress-bar>
  </div>

  <mat-card style="width: 500px;" *ngIf="alreadySubscribed">

    <div>
      <div>
        <p>{{_caexService.currentMember.name }} já está inscrito(a).</p>
        <div *ngFor="let order of _caexService.memberOrders">
          <div>{{order.product_name}}</div>
        </div>
        <hr>
        <br>
        <p>Clique no botão abaixo para registrar a presença e visualizar o crachá</p>
        <button mat-raised-button (click)="gotoToten(_caexService.currentMember.cpf)" style='width:160px;'>
          {{_caexService.currentMember.cpf }}
        </button>

      </div>


    </div>

  </mat-card>

  <mat-card style="width: 500px;" *ngIf="!alreadySubscribed">
    
    <div style="padding:10px 0 10px 0; color:rgba(63,72,204,.8);">
      <b>Clique abaixo para inscrever {{_caexService.currentMember.name}}</b>
    </div>
    <!-- TABLE -->
    <mat-table [dataSource]="dataSourceProducts">

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef> Nome </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.name }}
        </mat-cell>
      </ng-container>

      <!-- Header -->
      <mat-header-row *matHeaderRowDef="displayedColumnsProducts"></mat-header-row>

      <!-- Row  -->
      <mat-row (click)='getProduct(row)' *matRowDef="let row; columns: displayedColumnsProducts;"></mat-row>

    </mat-table>
    <!-- END TABLE -->

  </mat-card>

</div>